import React from "react";
import axios from "axios";
import moment from "moment";
import { Link } from "react-router";
import ChapterIndex from "../../components/ChapterIndex";
import { downloadFile, downloadPublicFile, responseToDownload } from "../../functions.js";
import cx from "classnames";

export default class CoursesDownloads extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: props.params.itemID !== undefined,
            isPopup: props?.isPopup === true,
            errorMessage: {},
            your_reference: null,
            course: false,
            events: false
        };
    }

    componentDidMount = () => {
        this.getData();
    };

    getData = () => {
        // Get competenceprofile data to choose from and the course data itself
        axios
            .get("/v1/courses/" + this.props.params.itemID + "/")
            .then((course) => {
                axios.get("/v1/courses/" + this.props.params.itemID + "/events/").then((events) => {
                    this.setState({
                        course: course.data,
                        your_reference: `${course.data.id} - ${course.data.your_reference}`,
                        events: events.data.results
                    });
                });
                axios.get(`/v1/competenceprofiles/${course.data.competence_profile}/files/`).then((response) => {
                    this.setState({
                        competenceProfileFiles: response.data.results
                    });
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    downloadCertificates = () => {
        downloadFile(`/v1/courses/${this.props.params.itemID}/certificates/`);
    };

    render = () => {
        // event specific files:
        let eventDetails = [];

        if (this.state.events === false) {
            eventDetails.push(
                <tr key={"eventdetails-loading"}>
                    <td colSpan="5">Evenementen ophalen...</td>
                </tr>
            );
        } else {
            this.state.events?.forEach((event) => {
                if (!event.files || event.files.length === 0) {
                    return;
                }
                event.files?.forEach((file, i) => {
                    if (file.type === "knowledge-exam") {
                        eventDetails.push(
                            <tr key={`event-files-${i}`} onClick={(e) => downloadFile(file.url)}>
                                <td>{event.start_datetime ? moment(event.start_datetime).format("DD-MM-YYYY") : "N.N.B."}</td>
                                <td>Kennis examen</td>
                                <td colSpan={2}>
                                    {event.name}
                                    <br />
                                    {file.used_by?.full_name && (
                                        <span className="lighter">
                                            Gedownload door {file.used_by.full_name} op {moment(file.used).format("DD-MM-YYYY [om] HH:mm")}
                                        </span>
                                    )}
                                </td>
                                <td>
                                    <i className="fa fa-download" title={"Download dit bestand"} />
                                </td>
                            </tr>
                        );
                    }
                    if (file.type === "audit-document") {
                        eventDetails.push(
                            <tr key={`event-files-${i}`} onClick={(e) => downloadFile(file.url)}>
                                <td>{moment(file.created).format("DD-MM-YYYY")}</td>
                                <td>Controle document</td>
                                <td colSpan={2}>
                                    {file.name}
                                    <br />
                                    {file.description && <span className="lighter">{file.description}</span>}
                                </td>
                                <td>
                                    <i className="fa fa-download" title={"Download dit bestand"} />
                                </td>
                            </tr>
                        );
                    }
                });
            });

            this.state.events
                ?.filter((event) => event.type === "knowledge-exam" && event.knowledge_exam_available)
                ?.forEach((event) => {
                    if (event.knowledge_exam_url === null || this.state.course.is_cancelled) {
                        // explain why it's not available
                        const usedBy = event.knowledge_exam_used_by?.full_name && (
                            <span className="lighter">
                                Gedownload door {event.knowledge_exam_used_by.full_name} op {moment(event.knowledge_exam_used).format("DD-MM-YYYY [om] HH:mm")}
                            </span>
                        );

                        const availableFrom = moment(event.knowledge_exam_available.from_date);
                        const availableUntil = moment(event.knowledge_exam_available.until_date);
                        const now = moment();

                        let available;
                        if (this.state.course.is_cancelled) {
                            available = "De cursus is geannuleerd";
                        } else if (!event.start_datetime) {
                            available = "Dit toetsmoment heeft nog geen startdatum.";
                        } else if (availableUntil.isBefore(now, "day")) {
                            // we could mention until it was available?
                            available = "Deze download is niet (langer) beschikbaar.";
                        } else if (availableFrom.isAfter(now)) {
                            available = (
                                <>
                                    Beschikbaar op {availableFrom.format("DD-MM-YYYY")}
                                    {/*" tot "}{availableUntil.format("DD-MM-YYYY")*/}
                                </>
                            );
                        } else {
                            // the dates say it's available, but there's no URL!
                            available = "De download is vanwege een onbekende reden niet beschikbaar. Neem contact op met NIBHV.";
                        }

                        eventDetails.push(
                            <tr key={"eventdetails" + event.uuid}>
                                <td>{event.start_datetime ? moment(event.start_datetime).format("DD-MM-YYYY") : "N.N.B."}</td>
                                <td>Kennis examen</td>
                                <td colSpan={3}>
                                    {event.name}
                                    {usedBy && (
                                        <>
                                            <br />
                                            {usedBy}
                                        </>
                                    )}
                                    {available && (
                                        <>
                                            <br />
                                            <span className="lighter">{available}</span>
                                        </>
                                    )}
                                </td>
                            </tr>
                        );
                    }
                });
        }

        // Always add the answer sheet as a download
        eventDetails.push(
            <tr key={"eventdetails-genericdownload"} onClick={(e) => downloadPublicFile("Antwoordblad Theorietoets NIBHV 2020 V2.1.pdf")}>
                <td>N.v.t.</td>
                <td>Antwoordblad</td>
                <td colSpan={2}>Antwoordblad Theorietoets (pdf)</td>
                <td>
                    <i className="fa fa-download" title={"Download dit bestand"}></i>
                </td>
            </tr>
        );
        if (eventDetails.length === 0) {
            eventDetails.push(
                <tr key={"eventdetails-noresults"}>
                    <td colSpan="5">Er zijn geen downloads voor deze cursus beschikbaar</td>
                </tr>
            );
        }

        let downloadButton = false;

        if (this.state.events && this.state.course) {
            // Check if there is at least one student that has achieved a certificate
            if (this.props.certificates?.length > 0) {
                downloadButton = (
                    <span>
                        <p>Download hier alle certificaten van de cursisten in deze cursus als ZIP bestand.</p>
                        <div className="btn btn-primary" onClick={() => this.downloadCertificates()}>
                            Download certificaten (zip)
                        </div>
                    </span>
                );
            } else {
                downloadButton = <div className="alert alert-warning">Er zijn nog geen certificeringen beschikbaar.</div>;
            }
        } else if (this.state.events && this.state.course && !this.state.course.is_finished) {
            downloadButton = "Zodra de cursus is afgerond kun je hier alle certificaten in een ZIP bestand downloaden.";
        }

        const files = this.state.competenceProfileFiles;

        return (
            <div>
                {this.state?.isPopup !== true && (
                    <div className="section-top">
                        <div className="breadcrumbs">
                            <Link to={"/courses"}>Cursussen</Link>
                        </div>
                        <h1>
                            <strong>{this.state.your_reference || "Laden..."}</strong>
                        </h1>
                    </div>
                )}

                <div className="row">
                    {this.state?.isPopup !== true && (
                        <div className="col-3 mt-4">
                            <ChapterIndex
                                chapters={[
                                    { title: "Cursisten", link: "/courses/edit/" + this.props.params.itemID + "/students" },
                                    { title: "Cursusgegevens", link: "/courses/edit/" + this.props.params.itemID + "/details" },
                                    { title: "Downloads", link: "/courses/edit/" + this.props.params.itemID + "/downloads" },
                                    { title: "Facturatie", link: "/courses/edit/" + this.props.params.itemID + "/invoices" }
                                ]}
                                isDirty={this.state.dirtyForm}
                                activeChapter={3}
                                {...this.props}
                            />
                        </div>
                    )}
                    <div className={cx(this.state?.isPopup !== true ? "col-9" : "col-12", "mt-4")}>
                        {this.state?.isPopup !== true && <h2 className="h1 mb-3">Downloads</h2>}

                        <div className="mt-3 mb-5">
                            <table className="table table-hover table-clickable">
                                <thead>
                                    <tr>
                                        <th width="120">Datum</th>
                                        <th width="160">Type</th>
                                        <th colSpan={2}>Details</th>
                                        <th width="110">Download</th>
                                    </tr>
                                </thead>
                                <tbody>{eventDetails}</tbody>
                            </table>

                            {files && files.length > 0 && (
                                <table className="table table-hover table-clickable">
                                    <thead>
                                        <tr>
                                            <th>Naam</th>
                                            <th width="200">Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {files.map((file, index) => {
                                            const download = (event) => {
                                                event.preventDefault();
                                                downloadFile(file.url);
                                            };
                                            return (
                                                <tr key={index} onClick={download}>
                                                    <td>
                                                        {file.name}
                                                        {file.description && <div className="text-muted">{file.description}</div>}
                                                    </td>
                                                    <td>
                                                        <i className="fa fa-download" title="Download dit bestand"></i>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="2">
                                                <i className="fa fa-download" />
                                                <button
                                                    type="button"
                                                    className="btn btn-link"
                                                    onClick={() => downloadFile(`/v1/competenceprofiles/${this.state.course.competence_profile}/files/all/`)}
                                                >
                                                    Download alle bestanden (zip)
                                                </button>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            )}
                        </div>

                        {downloadButton}

                        {/* #1609 - Credentials download is disabled. */}
                        {/* this.state.course?.students?.some(student => !student.email) && (
              <>
                <div className="alert alert-info mt-3">
                    <p>Er zijn op deze cursus cursisten die geen e-mailadres hebben. Hier kunnen tijdelijke inloggegevens worden gedownload zodat zij toegang tot Mijn NIBHV krijgen.</p>
                    <p><strong>Deze gegevens worden <u>eenmalig</u> verstrekt.</strong></p>
                    <p>Zorg dat deze gegevens goed worden beveiligd en neem contact op met NIBHV als de veiligheid hiervan in het geding is gekomen. Het is niet mogelijk, op welke manier dan ook, deze gegevens later opnieuw te verstrekken!</p>
                </div>
                <button className="btn btn-primary" onClick={(event) => {
                    event.preventDefault();
                    const url = `/v1/courses/${this.state.course.uuid}/login_credentials/`;
                    axios({
                        url,
                        method: "POST",
                        responseType: "blob",
                        headers: {
                            "Accept": "*" + "/*"
                        }
                    }).then(
                        (response) => {
                            if (response.status === 204) {
                                alert("Er zijn geen cursisten waar inloggegevens voor konden worden gemaakt.");
                                return;
                            }
                            responseToDownload(response);
                        }, (error) => console.error(error)
                    );
                }}>Download inloggevens voor cursisten</button>
              </>
            )*/}
                    </div>
                </div>
            </div>
        );
    };
}
